<script>
export default {
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  methods: {
    showDetails (type) {
      let typeEvent = type === 'CHECK-IN' ? 'CheckedIn' : 'CheckedOut'
      this.$emit('showDetails', typeEvent)
    }
  }
}
</script>

<template>
  <div class="card mini-stats-wid">
    <div class="card-body" style="padding: 1rem; min-height: 120px; display: flex; flex-direction: column; justify-content: space-between;">
      <div class="media">
        <div class="media-body text-left d-flex flex-column h-100">
          <div class="d-flex justify-content-between align-items-start flex-grow-1">
            <div>
              <p class="font-weight-medium mb-0 font-size-14" :class="'text-' + data.color">{{ data.title }}</p>
              <h4 class="mt-2 font-weight-bold">{{ data.value }}<span style="color: #a1a1a1" v-show="data.hasTags && data.color !== 'dark'">/{{ data.hasTags }}</span></h4>
            </div>
            <div class="align-self-start">
              <i :class="data.icon" :style="data.style"></i>
            </div>
          </div>
          <div class="mt-2 d-flex justify-content-end align-items-end" style="gap: 5px;">
            <i :class="data.iconText" style="font-size: 16px"></i>
            <p class="mb-0 font-size-13"><span :class="'text-' + data.colorText">{{ data.detail }}</span> {{ data.text }}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- end card-body -->
  </div>
  <!-- end card -->
</template>

<style scoped>
  .text-gray { color: #797979 !important; }
  .text-purple { color: #681AE8 !important; }
  .text-blue { color: #4D8FF2 !important; }
  .text-orange { color: #F26516 !important; }
  .text-green { color: #01B366 !important; }
  .text-white { color: #ffffff !important; }
  .text-red { color: #F51919 !important; }
  .bg-dark { background: #00000047 !important; color: #2b322e; }
  .bg-purple { background: #681ae847 !important; color: #2b322e; }
  .bg-blue { background: #4d8ff257 !important; color: #2b322e; }
  .bg-orange { background: #f265164f !important; color: #2b322e; }
  .bg-orange-dark { background: #f26716c5 !important; color: #2b322e; }
  .bg-green { background: #01b36669 !important; color: #2b322e; }
  .bg-green-dark { background: #34c38f !important; color: #2b322e; }
  .bg-red { background: #f5191966 !important; color: #2b322e; }

  .font-size-12 {
    font-size: 12px !important;
  }
  h4 {
    font-size: 24px !important;
    margin: 0;
  }
  i {
    font-size: 24px;
    align-self: flex-start;
  }
</style>
